import type { ReactNode } from 'react';

export const symbol_medication: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M440-380v72q0 17 11.74 28 11.73 11 28.5 11Q497-269 508-280.67q11-11.66 11-28.33v-71h74q16.67 0 28.33-11.74Q633-403.47 633-420.24q0-16.76-11.67-28.26Q609.67-460 593-460h-74v-72q0-17-11-28t-27.76-11q-16.77 0-28.5 11Q440-549 440-532v72h-73q-16.67 0-28.33 11.74Q327-436.53 327-419.76q0 16.76 11.67 28.26Q350.33-380 367-380h73ZM260-120q-24.75 0-42.37-17.63Q200-155.25 200-180v-479q0-24.75 17.63-42.38Q235.25-719 260-719h440q24.75 0 42.38 17.62Q760-683.75 760-659v479q0 24.75-17.62 42.37Q724.75-120 700-120H260Zm0-60h440v-479H260v479Zm10-600q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h421q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H270Zm-10 121v479-479Z"
		/>
	</svg>
);
